module.exports = __webpack_public_path__ + "img/imgRemove01.57cec6ed.png";